import { DocumentKind, ServiceKind } from "@bitory-gmbh/bsm";
import { RFC3339timestamp, UUID } from "@bitory-gmbh/nidavellir";
import { backendApi } from "@/services/backend/api";
import { DocumentData } from "@/services/backend/connect/types/document-data";

const documentDataApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["DocumentData"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      connectDocumentDataCreate: build.mutation<DocumentData, CreateRequest>({
        query: (request) => ({
          url: `/connect/document-data`,
          method: "POST",
          body: request,
        }),
        invalidatesTags: ["DocumentData"],
      }),
      connectDocumentDataShow: build.query<DocumentData, ShowRequest>({
        query: (request) => ({
          url: `/connect/document-data`,
          method: "GET",
          params: request,
        }),
        providesTags: (result) =>
          result
            ? ["DocumentData", { type: "DocumentData", id: result.id }]
            : [],
      }),
      connectDocumentDataUpdate: build.mutation<DocumentData, UpdateRequest>({
        query: (request) => ({
          url: `/connect/document-data`,
          method: "PATCH",
          body: request,
        }),
        invalidatesTags: (_result, _error, request) => [
          { type: "DocumentData", id: request.id },
          // needed to update PDF
          "HtzWorkOrder",
          "RltWorkOrder",
          "VbsWorkOrder",
        ],
      }),
      connectDocumentDataSetImmutable: build.mutation<
        DocumentData,
        SetImmutableRequest
      >({
        query: (request) => ({
          url: `/connect/document-data/immutable`,
          method: "PATCH",
          body: request,
        }),
        invalidatesTags: (_result, _error, request) => [
          { type: "DocumentData", id: request.id },
        ],
      }),
      connectDocumentDataDelete: build.mutation<DocumentData, DeleteRequest>({
        query: (request) => ({
          url: `/connect/document-data`,
          method: "DELETE",
          body: request,
        }),
        invalidatesTags: (_result, _error, request) => [
          { type: "DocumentData", id: request.id },
          { type: "DocumentData", id: "LIST" },
        ],
      }),
    }),
  });

export const {
  useConnectDocumentDataCreateMutation,
  useConnectDocumentDataShowQuery,
  useConnectDocumentDataUpdateMutation,
  useConnectDocumentDataSetImmutableMutation,
  useConnectDocumentDataDeleteMutation,
} = documentDataApi;

export interface CreateRequest {
  id: string;
  serviceKind: ServiceKind;
  documentKind: DocumentKind;
  documentId: UUID;
}

export interface ShowRequest {
  id?: string;
  serviceKind?: ServiceKind;
  documentKind?: DocumentKind;
  documentId?: UUID;
}

export interface UpdateRequest {
  id: string;
  number: string;
  customerNumber: string;
  objectNumber: string;
}

export interface SetImmutableRequest {
  id: string;
  reason: string;
  setBy: string;
  setAt: RFC3339timestamp;
}

export interface DeleteRequest {
  id: string;
}
